import React from 'react'
import PropTypes from 'prop-types'
import {
    Image
} from '@salesforce/retail-react-app/app/components/shared/ui'

const ResponsivePicture = ({ mobileSrc, tabletSrc, desktopSrc, alt = "", imageProps }) => {
    return (
        <picture>
            <source media="(min-width: 992px)" srcSet={desktopSrc} />
            <source media="(min-width: 768px)" srcSet={tabletSrc} />
            <Image src={mobileSrc} alt={alt} {...imageProps} />
        </picture>
    )
}

ResponsivePicture.propTypes = {
    mobileSrc: PropTypes.string.isRequired,
    desktopSrc: PropTypes.string.isRequired,
    alt: PropTypes.string,
    imageProps: PropTypes.object,
}

export default ResponsivePicture
